import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { Navigation, Scrollbar, A11y, EffectFade, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import { Link, useLocation } from 'react-router-dom';

function BannerThree() {
    const location = useLocation();

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            const headerHeight = 100;
            const elementPosition = element.offsetTop - headerHeight;
            
            window.scrollTo({
                top: elementPosition,
                behavior: 'smooth'
            });
            window.history.pushState(null, null, `#${sectionId}`);
        }
    };

    const handleBannerClick = (e, sectionId, path) => {
        if (location.pathname === '/') {
            e.preventDefault();
            scrollToSection(sectionId);
        }
    };

    return (
        <div>
            {/* banner area start three */}
            <div className="rts-banner-area banner-three" id='banner'>
                <div className="swiper ">
                    <Swiper
                        // install Swiper modules
                        modules={[Navigation, EffectFade, Scrollbar, A11y, Autoplay]}
                        className="mySwiperh3_banner"
                        speed={600}
                        slidesPerView={1}
                        spaceBetween={0}
                        loop={true}
                        autoplay={{
                            delay: 4000,
                        }}
                        breakpoints={{
                            1200: { slidesPerView: 1 },
                            900: { slidesPerView: 1 },
                            768: { slidesPerView: 1 },
                            580: { slidesPerView: 1 },
                            450: { slidesPerView: 1 },
                            0: { slidesPerView: 1 },
                        }}
                    >
                        <SwiperSlide>
                            <div className=" bg_banner-three bg_image rts-section-gap">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="banner-three-inner">
                                                <span className="subtitle-banner">
                                                    Peste 20 de ani de experiență
                                                </span>
                                                {/* type headline start*/}
                                                <h1 className="title cd-headline clip is-full-width">
                                                    Infrastructură Durabilă
                                                </h1>
                                                <p className="disc">
                                                    Izodrom Grup este liderul în sectorul construcțiilor și infrastructurii 
                                                    inginerești din Republica Moldova. Oferim soluții complete de la proiectare 
                                                    până la predare „la cheie" pentru construcții civile, industriale și sisteme 
                                                    de utilități moderne.
                                                </p>
                                                <div className="button-group">
                                                    <Link
                                                        to={'/project'}
                                                        className="rts-btn btn-primary-3"
                                                        onClick={(e) => handleBannerClick(e, 'projects', '/project')}
                                                    >
                                                        Vezi Proiectele
                                                    </Link>
                                                    <Link
                                                        to={'/about-us'}
                                                        className="rts-btn btn-primary-4 transparent"
                                                        onClick={(e) => handleBannerClick(e, 'about', '/about-us')}
                                                    >
                                                        Despre Noi
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className=" bg_banner-three slide-2 bg_image rts-section-gap">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="banner-three-inner">
                                                <span className="subtitle-banner">
                                                    Tehnologii moderne MBBR
                                                </span>
                                                {/* type headline start*/}
                                                <h1 className="title cd-headline clip is-full-width">
                                                    Stația de Epurare Moderne
                                                </h1>
                                                <p className="disc">
                                                    Specializați în proiectarea și execuția stațiilor de epurare a apelor uzate, 
                                                    folosind tehnologii avansate MBBR și sisteme moderne de tratare. Proiecte 
                                                    regionale cu capacități de la 1.500 m³/zi până la 2.400 m³/zi, adaptate 
                                                    nevoilor locale din Moldova.
                                                </p>
                                                <div className="button-group">
                                                    <Link
                                                        to={'/wastewater-treatment'}
                                                        className="rts-btn btn-primary-3"
                                                        onClick={(e) => handleBannerClick(e, 'services', '/wastewater-treatment')}
                                                    >
                                                        Soluții Epurare
                                                    </Link>
                                                    <Link
                                                        to={'/contactus'}
                                                        className="rts-btn btn-primary-4 transparent"
                                                        onClick={(e) => handleBannerClick(e, 'f-contact', '/contactus')}
                                                    >
                                                        Solicită Ofertă
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className=" bg_banner-three slide-3 bg_image rts-section-gap">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="banner-three-inner">
                                                <span className="subtitle-banner">
                                                    Construcții și infrastructură
                                                </span>
                                                {/* type headline start*/}
                                                <h1 className="title cd-headline clip is-full-width">
                                                    Dezvoltare Regională
                                                </h1>
                                                <p className="disc">
                                                    De la construcții civile și industriale până la sisteme complexe de 
                                                    alimentare cu apă și canalizare. Realizăm proiecte complete de infrastructură 
                                                    pentru dezvoltarea regională durabilă, cu suport tehnic și stabilitate 
                                                    financiară garantată.
                                                </p>
                                                <div className="button-group">
                                                    <Link
                                                        to={'/constructions'}
                                                        className="rts-btn btn-primary-3"
                                                        onClick={(e) => handleBannerClick(e, 'services', '/constructions')}
                                                    >
                                                        Construcții
                                                    </Link>
                                                    <Link
                                                        to={'/water-systems'}
                                                        className="rts-btn btn-primary-4 transparent"
                                                        onClick={(e) => handleBannerClick(e, 'services', '/water-systems')}
                                                    >
                                                        Sisteme Apă
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>
            {/* banner area end three */}
        </div>
    )
}

export default BannerThree